import { Reveal } from '../ui/Reveal';
import { Icons } from '../ui/Icons';

const SIGNALS = [
  { icon: 'badge' as const, label: 'CAPS-certified specialists' },
  { icon: 'shield' as const, label: 'One specialist, never an auction' },
  { icon: 'heart' as const, label: 'Free & no obligation' },
  { icon: 'clock' as const, label: 'Usually within 48 hours' },
];

export function TrustStrip() {
  return (
    <section className="relative border-y border-stone bg-blush">
      <div className="container-rosa">
        <Reveal y={14}>
          <ul className="flex flex-wrap items-center justify-center gap-x-3 gap-y-4 py-5 sm:gap-x-2 sm:py-6">
            {SIGNALS.map((s, i) => {
              const I = Icons[s.icon];
              return (
                <li key={s.label} className="flex items-center">
                  <span className="flex items-center gap-2.5 px-2 sm:px-4">
                    <I width={19} height={19} className="shrink-0 text-terracotta" />
                    <span className="font-body text-[13.5px] font-semibold text-plum sm:text-sm">{s.label}</span>
                  </span>
                  {i < SIGNALS.length - 1 && (
                    <span
                      className="hidden h-1.5 w-1.5 shrink-0 rounded-full bg-sage/50 sm:block"
                      aria-hidden="true"
                    />
                  )}
                </li>
              );
            })}
          </ul>
        </Reveal>
      </div>
    </section>
  );
}
